import PropTypes from 'prop-types'

export class CartItem { } 

CartItem.propTypes = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Price: PropTypes.string.isRequired,
  Quantity: PropTypes.number.isRequired,
  DisplayName: PropTypes.string.isRequired
})

